import { z } from "zod";

export const NotificationKindEnum = z.enum([
  "chat_message",
  "timeline_event",
  "assignment_event",
  "assignment_digest",
]);
export type NotificationKind = z.infer<typeof NotificationKindEnum>;

export const NotificationEventTypeEnum = z.enum([
  "chat_message_received",
  "chat_group_note_added",
  "project_note_added",
  "project_status_updated",
  "project_quote_updated",
  "project_assigned_to_expert",
  "project_assigned",
  "project_assignment_digest",
]);
export type NotificationEventType = z.infer<typeof NotificationEventTypeEnum>;

export const NotificationChatroomKindEnum = z.enum([
  "project_chatroom",
  "direct_chatroom",
]);
export type NotificationChatroomKind = z.infer<typeof NotificationChatroomKindEnum>;

export const NotificationMetadataValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
  z.array(z.string()),
  z.array(z.number()),
  z.array(z.boolean()),
]);
export type NotificationMetadataValue = z.infer<typeof NotificationMetadataValueSchema>;

export const NotificationMetadataSchema = z.record(
  z.string(),
  NotificationMetadataValueSchema,
).nullable().optional();
export type NotificationMetadata = z.infer<typeof NotificationMetadataSchema>;
